import { IdentityPanel } from '@/components/program-view/panels'
import {
  ADVANCED_FACE_DETECTION_EXTENSION_ID,
  HUMINT_EXTENSION_ID,
  useExtensionEnabled,
} from '@/hooks/use-extensions'
import { useCaseContext } from '../../CaseContext'

export default function IdentityPage() {
  const { caseId } = useCaseContext()
  // The face tabs are Advanced Face Detection's (ADR-0051), the voices tab HUMINT's (ADR-0077);
  // the directory is the base product's.
  const faceDetection = useExtensionEnabled(ADVANCED_FACE_DETECTION_EXTENSION_ID)
  const humint = useExtensionEnabled(HUMINT_EXTENSION_ID)
  return (
    <IdentityPanel caseId={caseId} faceDetection={faceDetection.enabled} humint={humint.enabled} />
  )
}
